import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DefaultLayout from "../../components/layout/DefaultLayout";
import { StaffTable } from "../../components/staff/StaffTable";

export const Staffs = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {}, []);

  return (
    <DefaultLayout>
      <Container>
        {user?.role !== "admin" ? (
          <h1>You are not authorized to view this page. Contact manager.</h1>
        ) : (
          <>
            <Row>
              <Col className="d-flex justify-content-between">
                <h1>Staffs</h1>
                <Button onClick={() => navigate("/staff/registration")}>
                  New Staff
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <StaffTable />
              </Col>
            </Row>
          </>
        )}
      </Container>
    </DefaultLayout>
  );
};
